import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const HeightHistoryPage = lazy(() => import("./HeightHistoryPage"));

const HeightHistoryPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <HeightHistoryPage />
    </Suspense>
  );
};

export default HeightHistoryPageLazy;
